import { render, staticRenderFns } from "./OfferProducts.vue?vue&type=template&id=56d51ecf&scoped=true&"
import script from "./OfferProducts.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OfferProducts.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./OfferProducts.vue?vue&type=style&index=0&id=56d51ecf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d51ecf",
  null
  
)

export default component.exports